import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ExamPreferenceModal from './ExamPreferenceModal';
import { readStoredUserData, useStoredUserData } from '../../authentication/userSession';
import { getAllowedExam } from '../../authentication/examAccess';

export const getExamLandingPath = (preferredExam, user = readStoredUserData()) => {
  const examType = getAllowedExam(user, preferredExam);
  if (examType === 'ielts') return '/ielts-dashboard';
  if (examType === 'pte') return '/pte-dashboard';
  return '/choose-exam';
};

export const PteDashboardEntry = ({ children }) => {
  const user = useStoredUserData();
  const landingPath = getExamLandingPath(localStorage.getItem('exam-type'), user);
  if (landingPath !== '/pte-dashboard') return <Navigate replace to={landingPath} />;
  return children;
};

const ExamPreferenceGate = () => {
  const user = useStoredUserData();
  const navigate = useNavigate();

  const handleSelectExam = (examType) => {
    localStorage.setItem('exam-type', examType);
    window.dispatchEvent(new CustomEvent('examTypeChanged', { detail: { examType } }));
    navigate(getExamLandingPath(examType), { replace: true });
  };

  if (user?.exam_access === 'ielts' || user?.exam_access === 'pte') {
    return <Navigate replace to={getExamLandingPath(null, user)} />;
  }
  return <ExamPreferenceModal open onSelect={handleSelectExam} />;
};

export const ExamLanding = () => {
  const user = useStoredUserData();
  return <Navigate replace to={getExamLandingPath(localStorage.getItem('exam-type'), user)} />;
};

export default ExamPreferenceGate;
